export const getCloseHeaderListFromLocalStorage = (key: string): string[] => {
  return JSON.parse(localStorage.getItem(key) || '[]');
};

export const setCloseHeaderListInLocalStorage = (
  key: string,
  value: string[]
): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const setUserAuthenticated = (): void => {
  localStorage.setItem('user', `true`);
};

export const removeUserAuthenticated = (): void => {
  localStorage.removeItem('user');
};

export const setIsLiveMerchant = (status: string): void => {
  localStorage.setItem('isLiveMerchant', status);
};

export const getIsLiveMerchant = (): string | null => {
  return localStorage.getItem('isLiveMerchant');
};

export const removeIsLiveMerchant = (): void => {
  localStorage.removeItem('isLiveMerchant');
};

export const setCurrentRoute = (path: string): void => {
  localStorage.setItem('currentRoute', path);
};

export const getCurrentRoute = (): string | null => {
  return localStorage.getItem('currentRoute');
};

export const removeCurrentRoute = (): void => {
  return localStorage.removeItem('currentRoute');
};
